import AccommodationDetails from './AccommodationDetails';
export default AccommodationDetails;
